define.alias("ember-cli-clipboard/modifiers/clipboard", "preview-grid/modifiers/clipboard");